import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';

export { CHERRY_DEV };

const BRAND_NAME = 'cherryDev';
const CLIENT_NAME = 'Anna Sanellia Silva';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_DEFAULT =
  `Hola ${BRAND_NAME}, vi la propuesta web para ${CLIENT_NAME}. Quiero elegir un plan y conocer los siguientes pasos.`;

export const buildPackageWhatsAppMessage = (planName) =>
  `Hola ${BRAND_NAME}, soy ${CLIENT_NAME}. Quiero el ${planName} de la propuesta web. ¿Me confirman alcance y forma de pago?`;

export const PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Propuesta web legal`;
export const PAGE_DESCRIPTION =
  'Propuesta cherryDev para Anna Sanellia Silva: web profesional, blog legal y agendamiento de citas. Tres planes desde $80 USD.';

export const hero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  clientRole: 'Abogado',
  title: 'Tu marca, servicios y blog legal en un solo sistema.',
  subtitle:
    'Deja de depender solo del DM. Una web que transmite autoridad, captura consultas y agenda citas mientras publicas análisis jurídicos.',
  cta: 'Ver planes de inversión',
  snapshot: {
    title: 'Brief de la propuesta',
    initials: 'AS',
    items: [
      { id: 'cliente', label: 'Cliente', value: CLIENT_NAME, icon: 'verified', span: 12 },
      { id: 'perfil', label: 'Perfil', value: 'Abogado', icon: 'gavel', span: 6 },
      { id: 'propuesta', label: 'Propuesta', value: 'cherryDev Web', icon: 'web', span: 6 },
    ],
    goalTags: ['Web', 'Servicios', 'Blog'],
  },
};

export const packages = {
  overline: 'Inversión',
  title: 'Elige el plan que mejor se adapta a tu presupuesto',
  subtitle: 'Tres opciones claras para arrancar, crecer o posicionarte como referente legal.',
  plans: [
    {
      id: 'esencial',
      name: 'Plan Esencial',
      tag: 'Opción 1',
      emoji: '💻',
      focus: 'Ideal para arrancar tu presencia digital con base sólida.',
      price: 80,
      priceNote: 'pago único',
      featured: false,
      badge: null,
      cta: 'Elegir Plan Esencial',
      features: [
        'Página web profesional de 5 secciones (Inicio, Sobre mí, Servicios, Contacto, etc.)',
        'Formulario de contacto directo',
        'Diseño adaptable a celulares y computadoras',
      ],
    },
    {
      id: 'profesional',
      name: 'Plan Profesional',
      tag: 'Opción 2',
      emoji: '⭐',
      focus: 'Combina captación con automatización para ahorrarte tiempo.',
      price: 150,
      priceNote: 'pago único',
      featured: true,
      badge: 'El más recomendado',
      cta: 'Elegir Plan Profesional',
      features: [
        'Todo lo del Plan Esencial',
        'Sección de blog básico para artículos y análisis legales',
        'Botones de llamada a la acción optimizados para WhatsApp',
      ],
    },
    {
      id: 'integral',
      name: 'Plan Integral / Autoridad',
      tag: 'Opción 3',
      emoji: '🚀',
      focus: 'Solución robusta para llevar tu despacho o marca al siguiente nivel.',
      price: 390,
      priceNote: 'pago único',
      featured: false,
      badge: 'Máxima personalización',
      cta: 'Elegir Plan Integral',
      features: [
        'Todo lo anterior con máxima personalización',
        'Blog avanzado con categorías legales y buscador interno',
        'Sistema completo de citas integrado',
        'Panel autoadministrable avanzado',
      ],
    },
  ],
};

export const whySystem = {
  overline: 'Por qué un sistema',
  title: 'Un abogado sin web profesional pierde consultas todos los días',
  subtitle:
    'Las redes muestran tu rostro; el sistema convierte esa confianza en citas, artículos indexados y clientes que llegan solos.',
  items: [
    {
      id: 'autoridad',
      title: 'Autoridad ante el cliente',
      text:
        'Un sitio propio transmite seriedad y respaldo. El potencial cliente ve servicios, trayectoria y formas de contacto sin esperar respuesta en el chat.',
      icon: 'gavel',
      color: 'primary',
    },
    {
      id: 'blog',
      title: 'Blog que trabaja por ti',
      text:
        'Cada artículo legal posiciona tu expertise en Google. Quien busca una respuesta puede encontrarte y convertirse en consulta.',
      icon: 'menuBook',
      color: 'secondary',
    },
    {
      id: 'citas',
      title: 'Citas sin idas y vueltas',
      text:
        'El agendamiento integrado elimina mensajes de “¿tienes disponible el martes?”. El cliente elige horario; tú recibes la solicitud organizada.',
      icon: 'event',
      color: 'primary',
    },
    {
      id: 'pagos',
      title: 'Cobra consultas por adelantado',
      text:
        'Con pasarela de pagos opcional reduces ausencias y filtras clientes serios antes de la primera reunión.',
      icon: 'money',
      color: 'secondary',
    },
  ],
  closing:
    'No es solo una página bonita: es tu despacho digital abierto 24/7 — visible, ordenado y listo para convertir visitas en asesorías.',
};

export const finalCta = {
  overline: 'Siguiente paso',
  title: '¿Cuál plan resuena más con tu presupuesto?',
  subtitle:
    'Escríbenos por WhatsApp y te confirmamos alcance, tiempos de entrega y forma de pago.',
  cta: 'Responder por WhatsApp',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Propuesta para ${CLIENT_NAME}`,
};
